import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const navLinks = [
  { to: "/dashboard", label: "Dashboard", roles: ["ADMIN", "MANAGER", "EMPLOYEE"], end: true },
  { to: "/users", label: "Users", roles: ["ADMIN"], end: true },
  { to: "/teams", label: "Teams", roles: ["ADMIN"], end: true },
  { to: "/evaluation-criteria", label: "Criteria", roles: ["ADMIN"], end: true },
  { to: "/evaluation-periods", label: "Periods", roles: ["ADMIN"], end: true },
  // { to: "/notifications", label: "Notifications", roles: ["ADMIN", "MANAGER"], end: true },
  {
    to: "/evaluations/new",
    label: "Submit Evaluation",
    roles: ["MANAGER", "EMPLOYEE"],
    end: true,
  },
  { to: "/evaluations", label: "Evaluations", roles: ["MANAGER", "EMPLOYEE"], end: true },
  { to: "/team-evaluations/new", label: "Team Eval", roles: ["MANAGER"], end: true },
  { to: "/team-evaluations", label: "Team List", roles: ["MANAGER"], end: true },
  // { to: "/ai/insights", label: "AI Insights", roles: ["ADMIN", "MANAGER", "EMPLOYEE"], end: true },
];

function Layout() {
  const { user, logout } = useAuth();
  const isAuthed = !!user;

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="mx-auto container-max px-6 py-4 flex items-center justify-between">
          <NavLink to="/" className="text-lg font-semibold text-brand-muted">
            Your Evaluation
          </NavLink>
          <nav className="flex items-center gap-4 text-sm font-medium">
            {isAuthed &&
              navLinks
                .filter((link) => !user?.role || link.roles.includes(user.role))
                .map((link) => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    end={link.end}
                    className={({ isActive }) =>
                      `px-3 py-1 rounded-md transition-colors ${
                        isActive
                          ? "bg-brand-primary text-white"
                          : "text-slate-700 hover:bg-slate-100"
                      }`
                    }
                  >
                    {link.label}
                  </NavLink>
                ))}
            {!isAuthed ? (
              <NavLink
                to="/login"
                className={({ isActive }) =>
                  `px-3 py-1 rounded-md border border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white transition-colors ${
                    isActive ? "bg-brand-primary text-white" : ""
                  }`
                }
              >
                Login
              </NavLink>
            ) : (
              <button
                type="button"
                onClick={logout}
                className="px-3 py-1 rounded-md border border-slate-300 text-slate-700 hover:bg-slate-100 transition-colors"
              >
                Logout ({user?.email})
              </button>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1 mx-auto container-max w-full px-6 py-8">
        <Outlet />
      </main>

      <footer className="bg-white border-t border-slate-200 text-sm text-slate-500">
        <div className="mx-auto container-max px-6 py-4 flex justify-between">
          <span>copyright 2026</span>
          <span>for Company</span>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
